import React from 'react'
import iconPackRegistry from '../iconPacks/registry'

interface LogoFlagPreviewProps {
  backgroundColor: string
  iconColor: string
  exactIconSize: number
  borderRadius: number
  borderWidth: number
  rotate: number
  icon: string
  iconPack?: string
  ratio: number
}

const LogoFlagPreview = ({
  backgroundColor,
  iconColor,
  exactIconSize,
  borderRadius,
  borderWidth,
  rotate,
  icon,
  iconPack = 'font-awesome-solid',
  ratio = 1,
}: LogoFlagPreviewProps) => {
  const pack =
    iconPackRegistry[iconPack] || iconPackRegistry['font-awesome-solid']
  const iconDef = pack.icons.find((i) => i.name === icon) || pack.icons[0]
  return (
    <div
      className="rounded-xl shadow-2xl flex items-center justify-center transition-all duration-600 ease-in-out"
      style={{
        backgroundColor: backgroundColor,
        borderRadius: `${borderRadius * ratio}px`,
        border: `${borderWidth * ratio}px solid ${iconColor}`,
        width: `${256 * ratio}px`,
        height: `${256 * ratio}px`,
      }}
    >
      {pack.getIconComponent(iconDef, exactIconSize * ratio, iconColor, rotate)}
    </div>
  )
}

export default LogoFlagPreview
